import React, { useState } from 'react'
import styles from './FiltersLine.module.scss'
import { PageTopContainer } from 'pages/utils'
import { DropdownSelect, DropdownSelectOptionType, IconButton } from 'components'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { VIEWERS_STORE, FilterEnums, ViewerPageTabTypes } from 'store'
import { Props } from './types'
import cl from 'classnames'
import { IconFilter, colors, IconClose } from 'assets'

const FiltersLineComponent = (props: Props) => {
  const {
    [VIEWERS_STORE]: {
      viewerPageSelectedTab: selectedTab,
      projectsAsDropdownOptions,
      projectTypesAsDropdownOptions,
      projectGenresAsDropdownOptions,
      brandsAsDropdownOptions,
      eventTypesAsDropdownOptions,
      setFilters,
      clearAllFilters
    }
  } = props

  const [filterKeyFix, setKeyFix] = useState(new Date().getMilliseconds())

  const onChange = (filterType: FilterEnums) => (selection: DropdownSelectOptionType[]) => {
    setFilters(filterType, selection)
  }

  const handleClearAllFilters = () => {
    clearAllFilters()
    setKeyFix(new Date().getMilliseconds())
  }

  const dropdowns = {
    [ViewerPageTabTypes.TOTAL_WATCH_VIDEO]: [
      {
        filterType: FilterEnums.PROJECT,
        options: projectsAsDropdownOptions,
        placeholder: 'Project'
      },
      {
        filterType: FilterEnums.PROJECT_TYPE,
        options: projectTypesAsDropdownOptions,
        placeholder: 'Type'
      },
      {
        filterType: FilterEnums.GENRE,
        options: projectGenresAsDropdownOptions,
        placeholder: 'Genre'
      }
    ],
    [ViewerPageTabTypes.TOTAL_INTERACTION_TIME]: [
      {
        filterType: FilterEnums.BRAND,
        options: brandsAsDropdownOptions,
        placeholder: 'Brand'
      },
      {
        filterType: FilterEnums.PROJECT,
        options: projectsAsDropdownOptions,
        placeholder: 'Project'
      }
    ],
    [ViewerPageTabTypes.ADD_REVENUE]: [
      {
        filterType: FilterEnums.EVENT,
        options: eventTypesAsDropdownOptions,
        placeholder: 'Event'
      },
      {
        filterType: FilterEnums.BRAND,
        options: brandsAsDropdownOptions,
        placeholder: 'Brand'
      },
      {
        filterType: FilterEnums.PROJECT,
        options: projectsAsDropdownOptions,
        placeholder: 'Project'
      }
    ],
    [ViewerPageTabTypes.TOTAL_SPEND]: [
      {
        filterType: FilterEnums.BRAND,
        options: brandsAsDropdownOptions,
        placeholder: 'Brand'
      },
      {
        filterType: FilterEnums.PROJECT,
        options: projectsAsDropdownOptions,
        placeholder: 'Project'
      }
    ]
  }[selectedTab] || []

  return (
    <PageTopContainer preset='filter'>
      <IconFilter fill={colors.borderGrey} opacity='0.6' style={{ marginRight: 15 }} width={'2rem'} height={'2rem'} />
      {dropdowns.map((props, index) =>
        <DropdownSelect
          key={index + filterKeyFix}
          className={cl({ [styles.marginLeft]: index > 0 })}
          onChange={onChange(props.filterType)}
          {...props}
        />
      )}

      <IconButton
        icon={IconClose}
        svgProps={{ opacity: '0.5' }}
        className={styles.clearButton}
        title='Clear all filters'
        onClick={handleClearAllFilters}
      />
    </PageTopContainer>
  )
}

const FiltersLine = inject(VIEWERS_STORE)(observer(FiltersLineComponent))
export { FiltersLine }
